import React from 'react';
import {ReactComponent as LogoBrandmark} from "../assets/images/logo-new-brandmark.svg";
import Layout from "../components/common/Layout";
import ResetPasswordForm from "../components/forms/ResetPasswordForm";
import styles from "../styles/common/Login.module.scss";

function ResetPassword() {
  return (
    <Layout
      pageTitle="Reset Password - Liquid Credit"
      hideHeader
      pageBodyClassName={styles.loginPage}
    >
      <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
          <div className={styles.logoIcon}>
            <LogoBrandmark />
          </div>
          <span className={styles.logoText}>Liquid Credit</span>
        </div>

        <div className={styles.loginCard}>
          <div className={styles.loginHeader}>
            <h2 className={styles.loginTitle}>
              Reset Password
            </h2>
            <p className={styles.loginSubtitle}>
              Enter your email to receive reset instructions
            </p>
          </div>

          <ResetPasswordForm />
          
          <div className={styles.supportLink}>
            <span>Need help? </span>
            <a href="mailto:support@liquidcredit.co" className={styles.contactLink}>
              Contact Support
            </a>
          </div>
        </div>

        <div className={styles.securityNotice}>
          All transactions on Liquid Credit protected by enterprise-grade security.
        </div>
      </div>
    </Layout>
  );
}

export default ResetPassword;